import React, { ReactNode } from 'react'
import { Paper, Typography } from '@mui/material'

interface IPageDescriptionComponent {
  textContent: ReactNode
  showBorder?: boolean
  backgroundColor?: string
  style?: React.CSSProperties
  padding?: any
}

const PageDescriptionComponent: React.FunctionComponent<IPageDescriptionComponent> = (
  props: IPageDescriptionComponent,
) => {
  return (
    <Paper
      variant="outlined"
      style={{
        padding: props.padding || '20px',
        margin: '0px 0px 10px 0px',
        maxWidth: '800px',
        width: '100%',
        border: props.showBorder ? 'auto' : 'none',
        backgroundColor: props.backgroundColor || '#f5f5f5',
        ...props.style,
      }}
    >
      <Typography component={'div'} variant="body2">
        {props.textContent}
      </Typography>
    </Paper>
  )
}

export default PageDescriptionComponent
